import React, { useState } from "react";
import { Button, ForumFollowBox } from "../../components";
import Slider from "react-slick";
import { Typography } from "antd";
import PSG from "../../assets/psg.JPG";
import { sliderSettings } from "./sliderSettings";
import "./style.css";

const { Title } = Typography;

const teams = [
  {
    img: PSG,
    title: "PSG Fans",
  },
  {
    img: PSG,
    title: "Football Updates",
  },
  {
    img: PSG,
    title: "NBA",
  },
  {
    img: PSG,
    title: "Chelsea Fan Club",
  },
  {
    img: PSG,
    title: "Volley Ball",
  },
  {
    img: PSG,
    title: "Football Academy",
  },
  {
    img: PSG,
    title: "Volley Ball",
  },
  {
    img: PSG,
    title: "Football Academy",
  },
];

const SuggestedForum = () => {
  const [tags, setTags] = useState([]);

  const onChangeTags = (tag) => {
    if (tags.indexOf(tag) > -1) {
      setTags(tags.filter((item) => item !== tag));
    } else {
      setTags((arr) => [...arr, tag]);
    }
  };

  return (
    <>
      <Title level={3}> Suggested Forums </Title>
      <Title level={5}> What are you interested in? </Title>
      <div className="mt-10 mb-5">
        <Slider {...sliderSettings}>
          <div>
            <Button
              type="primary"
              className="mt-10 primary-color button-tetiary"
              title="All Forum"
              style={{ height: "50px", width: "60%", borderRadius: "30px" }}
            />
          </div>
          <div>
            <Button
              type="primary"
              className="mt-10 primary-color button-transparent-tetiary"
              title="Soccer"
              style={{ height: "50px", width: "60%", borderRadius: "30px" }}
            />
          </div>
          <div>
            <Button
              type="primary"
              className="mt-10 primary-color button-transparent-tetiary"
              title="Basketball"
              style={{ height: "50px", width: "60%", borderRadius: "30px" }}
            />
          </div>
          <div>
            <Button
              type="primary"
              className="mt-10 primary-color button-transparent-tetiary"
              title="Tennis"
              style={{ height: "50px", width: "60%", borderRadius: "30px" }}
            />
          </div>
          <div>
            <Button
              type="primary"
              className="mt-10 primary-color button-transparent-tetiary"
              title="Cricket"
              style={{ height: "50px", width: "60%", borderRadius: "30px" }}
            />
          </div>
          <div>
            <Button
              type="primary"
              className="mt-10 primary-color button-transparent-tetiary"
              title="Tennis"
              style={{ height: "50px", width: "60%", borderRadius: "30px" }}
            />
          </div>
          <div>
            <Button
              type="primary"
              className="mt-10 primary-color button-transparent-tetiary"
              title="Cricket"
              style={{ height: "50px", width: "50%", borderRadius: "30px" }}
            />
          </div>
        </Slider>
      </div>
      <div className="block grid grid-cols-1 md:grid-cols-2 gap-x-0 2xl:gap-x-0 grid-rows-1 mt-10 mb-5">
        {teams.map((item, index) => (
          <div key={index}>
            <ForumFollowBox
              image={item.img}
              title={item.title}
              count={13}
              type={"Public"}
              onClick={() => onChangeTags(item.title)}
              buttonText={tags.indexOf(item.title) > -1 ? "Unfollow" : "Follow"}
            />
          </div>
        ))}
      </div>
      <div className="text-center mt-10">
        <p>Load More</p>
      </div>
    </>
  );
};

export default SuggestedForum;
